// src/utils/syncUserToFirestore.js
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export const syncUserToFirestore = async (user) => {
  if (!user?.id) return;

  const userRef = doc(db, "users", user.id);

  await setDoc(
    userRef,
    {
      id: user.id,
      email: user.primaryEmailAddress?.emailAddress,
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      createdAt: user.createdAt?.toString() || "",
      updatedAt: serverTimestamp(),
    },
    { merge: true } // this ensures we don’t overwrite existing fields
  );
};
